const n = (e, i) => {
  typeof (e == null ? void 0 : e.addEventListener) < "u" ? e.addEventListener("change", i) : typeof (e == null ? void 0 : e.addListener) < "u" && e.addListener(i);
}, d = (e, i) => {
  typeof (e == null ? void 0 : e.removeEventListener) < "u" ? e.removeEventListener("change", i) : typeof (e == null ? void 0 : e.removeListener) < "u" && e.removeListener(i);
};
export {
  n as a,
  d as r
};
